import axios from "axios";

/** Le PUT présigné vers S3 a répondu, mais par un refus : le fichier n'est pas parti. */
export class VaporUploadError extends Error {
    constructor(status) {
        super(`S3 upload refused (HTTP ${status})`)
        this.name = "VaporUploadError"
        this.status = status
    }
}

/**
 * L'adresse présignée d'un envoi au stockage (`POST /vapor/signed-storage-url`) : `url`, `headers`
 * et `key`. Lue seule par un envoi qui part du disque (le signalement du live, sur mobile).
 */
export async function requestSignedStorageUrl(contentType, options = {}) {
    return axios.post(options.signedStorageUrl ? options.signedStorageUrl : '/vapor/signed-storage-url', {
        'bucket': options.bucket || '',
        'content_type': contentType,
        'expires': options.expires || '',
        'visibility': options.visibility || '',
        ...options.data
    }, {
        baseURL: options.baseURL || null,
        headers: options.headers || {},
        ...options.options
    });
}

/** L'étape où un envoi a cassé, posée sur l'erreur : l'appelant qui tient sa file la remonte. */
function failedAt(step, error) {
    if (error != null && typeof error === "object") error.uploadStep = step
    return Promise.reject(error)
}

export async function vaporStore(file, options = {}) {
    const response = await requestSignedStorageUrl(options.contentType || file.type, options)
        .catch(error => failedAt("signed_url", error));

    let headers = response.data.headers;

    // if (typeof options.onUploadProgress === 'undefined') {
    //     options.onUploadProgress = () => {
    //     };
    // }

    // const cancelToken = options.cancelToken || ''

    // TODO : add upload progress
    // option 1 : keep fetch and add to it progress logic (library ?)
    // option 2 : use XMLHttpRequest https://finnian.io/blog/uploading-files-to-s3-react-native-ruby-on-rails/ and https://gist.github.com/developius/1fa35f2192b886dfce4e7f4eaed8b923#file-axios_gcs_expo_example-ts
    const upload = await fetch(response.data.url, {
        method: 'PUT',
        headers: headers,
        body: file
    })
        .catch(error => {
            console.log('Error:', JSON.stringify(error, null, 2))
            return failedAt("put", error)
        })

    // Un refus de S3 (403, 5xx) répond quand même : sans cette lecture, la clé
    // revenait comme si le fichier était parti. Option d'un appelant qui tient
    // sa file d'envoi (le moteur de l'activité) ; le legacy garde l'ancien
    // comportement tant qu'il ne la passe pas.
    if (options.verifyUpload && !upload?.ok) {
        return failedAt("verify", new VaporUploadError(upload?.status ?? 0))
    }

    // delete axios.defaults.headers.common['Authorization']
    //
    // await axios.put(response.data.url, file, {
    //     // cancelToken: cancelToken,
    //     headers,
    //     onUploadProgress: options.onUploadProgress
    // })

    // response.data.extension = file._data.name.split('.').pop()

    return response.data;
}